import React from "react";

const DashboardPanel = ({header, children, className = ""}) => (
    <section className={`flex min-h-0 flex-col overflow-hidden rounded-sm border border-[#d8d8d8] bg-white ${className}`}>
        <div className="bg-gray-200 rounded-t-sm border-b border-gray-300 flex justify-start items-center">
            {header}
        </div>
        <div className="flex min-h-0 flex-1 flex-col relative gap-2">
            {children}
        </div>
    </section>
);

export default DashboardPanel;
